import type { ModalData } from '..';

export interface MtDeleteAccountModalFormValues {
  feedback: string;
}

export interface MtDeleteAccountModalData {
  modal: ModalData;
  isLoading: boolean;
}

export interface MtDeleteAccountModalProps extends MtDeleteAccountModalData {}
